import { AxiosService } from '../../../../axios/axios.service';
import { tAxiosCustomConfig } from '../../../../axios/axios.types';
import { tAgendaResponse, tTemplateV2 } from '../../Agenda.types';
import {
  tCreateEventRequest,
  tCreateTemplateRequest,
  tEventResponse,
  tEventResponseV2,
  tTemplateResponse,
  tUpdateEventRequest,
  tUpdateTemplateRequest,
} from './Calendar.types';

export const CalendarService = {
  getTemplates: async function (
    currentWorkspaceId: string,
  ): Promise<tAgendaResponse<{ templates: tTemplateV2[] }>> {
    try {
      const response = await AxiosService.get<
        tAgendaResponse<{ templates: tTemplateV2[] }>
      >(`agenda/templates?workspaceId=${currentWorkspaceId}`);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  createTemplate: async function (
    template: tCreateTemplateRequest,
  ): Promise<tAgendaResponse<tTemplateResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        isLegacy: true,
        headers: undefined,
      };

      const response = await AxiosService.post<
        tCreateTemplateRequest,
        tAgendaResponse<tTemplateResponse>
      >(`calendar/templates`, template, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  updateTemplate: async function (
    updatedTemplate: tUpdateTemplateRequest,
    templateID: string,
  ): Promise<tAgendaResponse<tTemplateResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        isLegacy: true,
        headers: undefined,
      };

      const response = await AxiosService.patchById<
        tUpdateTemplateRequest,
        tAgendaResponse<tTemplateResponse>
      >(`calendar/templates`, templateID, updatedTemplate, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  createEvent: async function (
    event: Partial<tCreateEventRequest>,
  ): Promise<tAgendaResponse<tEventResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        isLegacy: true,
        headers: undefined,
      };

      const response = await AxiosService.post<
        Partial<tCreateEventRequest>,
        tAgendaResponse<tEventResponse>
      >(`calendar/events`, event, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  getEventsByDate: async function (
    currentWorkspaceId: string,
    startDate: string,
    endDate: string,
  ): Promise<tAgendaResponse<{ events: tEventResponseV2[] }>> {
    try {
      const response = await AxiosService.get<
        tAgendaResponse<{ events: tEventResponseV2[] }>
      >(
        `agenda/events?workspaceId=${currentWorkspaceId}&startDate=${startDate}&endDate=${endDate}`,
      );

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  getEvents: async function (
    currentWorkspaceId: string,
  ): Promise<tAgendaResponse<tEventResponse[]>> {
    try {
      const config: tAxiosCustomConfig = {
        isLegacy: true,
        headers: undefined,
      };

      const response = await AxiosService.get<
        tAgendaResponse<tEventResponse[]>
      >(`calendar/events?workspace_id=${currentWorkspaceId}`, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  getEventByID: async function (
    eventID: string,
  ): Promise<tAgendaResponse<tEventResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        isLegacy: true,
        headers: undefined,
      };

      const response = await AxiosService.get<tAgendaResponse<tEventResponse>>(
        `calendar/events/${eventID}`,
        config,
      );

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  updateEvent: async function (
    eventID: string,
    event: Partial<tUpdateEventRequest>,
  ): Promise<tAgendaResponse<tEventResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        isLegacy: true,
        headers: undefined,
      };

      const response = await AxiosService.patchById<
        Partial<tUpdateEventRequest>,
        tAgendaResponse<tEventResponse>
      >(`calendar/events`, eventID, event, config);

      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  deleteEvent: async function (eventID: string): Promise<void> {
    try {
      const config: tAxiosCustomConfig = {
        isLegacy: true,
        headers: undefined,
      };

      await AxiosService.delete(`calendar/events/${eventID}`, config);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  sendReminder: async function (
    eventID: string,
    currentUserID: string,
  ): Promise<void> {
    try {
      const config: tAxiosCustomConfig = {
        headers: { 'Auth-id': currentUserID },
        isLegacy: true,
      };

      await AxiosService.post(
        `calendar/events/${eventID}/reminder`,
        null,
        config,
      );
    } catch (err) {
      return Promise.reject(err);
    }
  },
};
